import { useState } from "react";

function NotepadIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 20 20" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Notepad body - yellow */}
      <rect x="3" y="2" width="12" height="16" rx="1" fill="#FBBF24" stroke="#92400E" strokeWidth="0.7" />
      {/* Folded corner */}
      <path d="M15 2 L15 6 L11 2 Z" fill="#F59E0B" stroke="#92400E" strokeWidth="0.5" strokeLinejoin="round" />
      {/* Lined paper */}
      <line x1="5.5" y1="6" x2="12.5" y2="6" stroke="#92400E" strokeWidth="0.35" opacity="0.4" />
      <line x1="5.5" y1="8.5" x2="12.5" y2="8.5" stroke="#92400E" strokeWidth="0.35" opacity="0.4" />
      <line x1="5.5" y1="11" x2="12.5" y2="11" stroke="#92400E" strokeWidth="0.35" opacity="0.4" />
      <line x1="5.5" y1="13.5" x2="10" y2="13.5" stroke="#92400E" strokeWidth="0.35" opacity="0.4" />
      {/* Pen at angle */}
      <g transform="rotate(-35 16 14)">
        <rect x="14.5" y="8" width="1.8" height="9" rx="0.4" fill="#78716C" stroke="#44403C" strokeWidth="0.4" />
        <polygon points="14.5,17 16.3,17 15.4,19" fill="#44403C" />
        <rect x="14.5" y="8" width="1.8" height="1.5" rx="0.3" fill="#A8A29E" />
      </g>
    </svg>
  );
}
import { useNoteCount } from "@/hooks/useEpisodeNotes";
import { useAuth } from "@/contexts/AuthContext";
import NoteEditorModal from "@/components/NoteEditorModal";

interface NoteButtonProps {
  episodeId: string;
  episodeTitle: string;
  audioUrl?: string | null;
  durationSeconds?: number | null;
  podcastName?: string;
  artworkUrl?: string | null;
  /** Current playback time in seconds if audio is playing */
  currentPlaybackTime?: number | null;
}

export default function NoteButton({
  episodeId,
  episodeTitle,
  audioUrl,
  durationSeconds,
  podcastName,
  artworkUrl,
  currentPlaybackTime,
}: NoteButtonProps) {
  const { user } = useAuth();
  const count = useNoteCount(episodeId);
  const [open, setOpen] = useState(false);

  if (!user) return null;

  return (
    <>
      <button
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setOpen(true);
        }}
        className="comic-play-btn relative overflow-hidden flex items-center gap-1 text-[10px] sm:text-xs font-mono font-bold px-2 sm:px-3 py-1 border-[2px] rounded-md bg-[hsl(195,85%,90%)] text-[hsl(195,80%,20%)] border-[hsl(195,80%,28%)] shadow-[3px_3px_0px_0px_hsl(var(--foreground))] hover:shadow-[1px_1px_0px_0px_hsl(var(--foreground))] hover:translate-x-[2px] hover:translate-y-[2px] transition-all duration-150 transform hover:scale-[1.03] hover:rotate-[-0.5deg] active:scale-95"
        title={count > 0 ? `${count} note${count !== 1 ? "s" : ""}` : "Add note"}
      >
        <NotepadIcon className="w-3 h-3 relative z-10" />
        <span className="relative z-10">{count > 0 ? `Notes (${count > 9 ? "9+" : count})` : "+Note"}</span>
      </button>

      <NoteEditorModal
        open={open}
        onClose={() => setOpen(false)}
        episodeId={episodeId}
        episodeTitle={episodeTitle}
        audioUrl={audioUrl}
        durationSeconds={durationSeconds}
        podcastName={podcastName}
        artworkUrl={artworkUrl}
        initialTimestamp={currentPlaybackTime}
      />
    </>
  );
}
